<template>
  <v-container>
    <v-row align="center" justify="center" class="my-4">
      <div>
        <img
          src="@/assets/pago_distancia.png"
          alt="Pago a distancia de Billpocket"
          height="120">
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Header',
};
</script>
